import { FieldArray } from 'react-final-form-arrays';
import { connect } from 'react-redux';

import { IKnmLegalBasisParams } from 'APIPackage/KnmModule/interfaces/IKnmLegalBasisParams';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { getKnmFormRef } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { CloseButton } from 'UIPackage/MainModule/components/CloseButton';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import styles from './KnmLegalBases.module.scss';

interface IKnmLegalBasesProps {
  className?: string;
  fieldName: string;
  watchOnly?: boolean;
}

interface IKnmLegalBasesStoreProps {
  formRef: IKnmFormRef | undefined;
}

const KnmLegalBasesWithoutStore = ({
  className = '',
  fieldName,
  watchOnly,
  formRef,
}: IKnmLegalBasesProps & IKnmLegalBasesStoreProps) => {
  const remove = formRef?.current.mutators.remove;
  const makeRemoveLegalBasisHandler = (index: number) => () => !watchOnly && remove && remove(fieldName, index);

  return (
    <FieldArray name={fieldName}>
      {({ fields }) => {
        if (!fields.length) {
          return null;
        }

        return (
          <ul className={className ? `${styles.List} ${className}` : styles.List}>
            {fields.map((name, index) => {
              const parametersTextArray = [];
              const legalBasis: IKnmLegalBasisParams = fields.value[index];
              const { atrI, atrII, atrIII, atrIV, atrV } = legalBasis;

              if (atrI) {
                parametersTextArray.push(`Раздел ${atrI}`);
              }
              if (atrII) {
                parametersTextArray.push(`Глава ${atrII}`);
              }
              if (atrIII) {
                parametersTextArray.push(`Статья ${atrIII}`);
              }
              if (atrIV) {
                parametersTextArray.push(`Пункт ${atrIV}`);
              }
              if (atrV) {
                parametersTextArray.push(`Часть ${atrV}`);
              }
              const parametersText = parametersTextArray.join(', ');

              return (
                <li className={styles.LegalBasis} key={name}>
                  <div className={styles.LegalBasisText}>
                    {`${legalBasis.atrNumber ? `№:${legalBasis.atrNumber} ` : ''}${
                      legalBasis.atrDate
                        ? `от ${formatDate({ date: legalBasis.atrDate, dateFormat: DATE_FORMAT_LONG_FNS })} `
                        : ''
                    }${legalBasis.documentName} ${parametersText}`}
                  </div>
                  <CloseButton onClick={makeRemoveLegalBasisHandler(index)} />
                </li>
              );
            })}
          </ul>
        );
      }}
    </FieldArray>
  );
};

const mapStateToProps = (state: IRootState): IKnmLegalBasesStoreProps => ({
  formRef: getKnmFormRef(state),
});

export const KnmLegalBases = connect(mapStateToProps)(KnmLegalBasesWithoutStore);
